import React, { useState } from "react";
import { Users, Search } from "react-feather";
import DetailModal from "./DetailModal";

const CustomerIntelligence = () => {
  const [selectedHeatMapItem, setSelectedHeatMapItem] = useState(null);
  const [selectedDetailModal, setSelectedDetailModal] = useState(null);

  const customerSegmentHeatMap = [
    {
      name: "Construction Contractors",
      players: 4,
      companies: ["Henkel", "H.B. Fuller", "Bostik", "Tailored"],
      color: "custom-danger",
      marketSize: "$12.5B",
      dataKey: "custseg-1",
    },
    {
      name: "Packaging Converters & CPG",
      players: 4,
      companies: ["Henkel", "H.B. Fuller", "Bostik", "Tailored"],
      color: "custom-danger",
      marketSize: "$10.8B",
      dataKey: "custseg-0",
    },
    {
      name: "Automotive OEMs & Tier 1",
      players: 3,
      companies: ["Henkel", "H.B. Fuller", "Bostik"],
      color: "custom-info",
      marketSize: "$8.2B",
      dataKey: "custseg-2",
    },
    {
      name: "Hygiene Product Manufacturers",
      players: 3,
      companies: ["H.B. Fuller", "Henkel", "Bostik"],
      color: "custom-info",
      marketSize: "$4.2B",
      dataKey: "custseg-4",
    },
    {
      name: "Woodworking & Furniture",
      players: 4,
      companies: ["Tailored", "Henkel", "H.B. Fuller", "Bostik"],
      color: "custom-danger",
      marketSize: "$3.8B",
      dataKey: "custseg-3",
    },
  ];

  const customerIntelligence = {
    henkel: {
      dataDepth: "Strong",
      segmentation: "Leader",
      personalization: "Strong",
      voiceOfCustomer: "Strong",
      highlight:
        "Co-creation labs with automotive OEMs for EV battery adhesives",
      quote:
        "Henkel's technical centers provide real-time application engineering support",
    },
    hbfuller: {
      dataDepth: "Strong",
      segmentation: "Leader",
      personalization: "Leader",
      voiceOfCustomer: "Leader",
      highlight:
        "Dedicated hygiene innovation centers with diaper manufacturer partnerships",
      quote: "100% adhesives focus enables deep customer application expertise",
    },
    bostik: {
      dataDepth: "Strong",
      segmentation: "Strong",
      personalization: "Strong",
      voiceOfCustomer: "Strong",
      highlight: "Construction contractor training programs and certification",
      quote:
        "Strong relationships with building material distributors across Europe",
    },
    tailored: {
      dataDepth: "Moderate",
      segmentation: "Moderate",
      personalization: "Leader",
      voiceOfCustomer: "Leader",
      highlight: "Custom formulations for regional woodworking customers",
      quote:
        "Small size allows rapid response to customer-specific requirements",
    },
  };

  const companies = [
    { id: "henkel", name: "Henkel", bgColor: "danger" },
    { id: "hbfuller", name: "H.B. Fuller", bgColor: "primary" },
    { id: "bostik", name: "Bostik", bgColor: "info" },
    { id: "tailored", name: "Tailored Chemical", bgColor: "secondary" },
  ];

  return (
    <div>
      <style>{`
        .segment-item {
          transition: all 0.3s ease;
          cursor: pointer;
        }
        .segment-item:hover {
          transform: scale(1.02);
          box-shadow: 0 4px 8px rgba(0,0,0,0.1);
        }
        .selected-segment {
          transform: scale(1.05);
          box-shadow: 0 6px 12px rgba(0,0,0,0.15);
        }
        .intelligence-card {
          border-radius: 8px;
          padding: 12px 16px;
          border: 1px solid;
        }
        .comp_map_block{
          border-bottom: 1px solid #e9ecef;
          background-color: #fff;
          padding: 12px 16px;
          border: solid 1px #98a4aa33;
          border-radius: 8px;
        }
      .comp_subhead{
          font-size:14px;
          font-weight:600 !Important;
        }
        .comp_head_new{
          color:#2d343d !important;
          font-size:13px;
          line-height:17.5px;
          font-weight:600;
          margin-bottom:5px;
        }
        .comp_subhead_new{
          color:#64748B !important;
          font-size:13px;
          line-height:17.5px;
          font-weight:400;
          margin-bottom:5px;

        }
        .comp_head_number{
          color:#363b4b !important;
          font-size:13px;
          line-height:17.5px;
          font-weight:600;
        }
        .comp_subhead{
          font-size:14px;
          font-weight:600 !Important;
        }
        .comp_head_new{
          color:#2d343d !important;
          font-size:13px;
          line-height:17.5px;
          font-weight:600;
          margin-bottom:5px;
        }
        .comp_subhead_new{
          color:#64748B !important;
          font-size:13px;
          line-height:17.5px;
          font-weight:400;
          margin-bottom:5px;

        }
        .comp_head_number{
          color:#363b4b !important;
          font-size:13px;
          line-height:17.5px;
          font-weight:600;
        }
        .bg-custom-danger{
          background-color: #fef2f2;
          border-left: 4px solid #b91c1c !important;
        }
        .bg-custom-danger-only{
          background-color: #b91c1c;
        }
        .bg-custom-info{
          background-color: #eff6ff;
          border-left: 4px solid #1e74e6 !important;
        }
        .bg-custom-info-only{
          background-color: #1e74e6;
        }
        .bg-custom-success{
          background-color: #f0fdf4;
          border-left: 4px solid #15803d !important;
        }
        .bg-custom-success-only{
          background-color: #15803d;
        }
        .bg-custom-warning-only{
          background-color: #CFAB69;
        }
        .bg-custom-warning{
          background-color: #feebc89c;
          border-left: 4px solid #CFAB69 !important;
        }
        .score_inter{
          font-weight: 400;
    font-size: 12px;
    background-color: #f0f4fa;
    line-height: 1.4;
    color: rgba(0, 0, 0, 0.6);
    /* margin-top: 5px; */
    margin-bottom: 20px;
    padding: 12px 8px 12px 12px;
    border-radius: 8px;
        }


      `}</style>

      <DetailModal
        selectedDetailModal={selectedDetailModal}
        setSelectedDetailModal={setSelectedDetailModal}
      />

      {/* Customer Segment Heat Map */}
      <div className="card border-0 mb-4">
        <div className="card-body comp_map_block">
          <h3 className="exe_summary mb-4">Customer Segment Heat Map</h3>

          <div>
            <div className="d-flex align-items-center gap-2 text-purple fw-bold small mb-3 font13">
              <Users size={16} />
              Key Customer Segments
            </div>
            <div className="row g-3">
              {customerSegmentHeatMap.map((item, idx) => {
                const itemKey = item.dataKey || `custseg-${idx}`;
                const isSelected = selectedHeatMapItem === itemKey;

                return (
                  <div key={idx} className="col-md-4">
                    <div
                      className={`segment-item bg-${
                        item.color
                      } bg-opacity-10 border-start border-${
                        item.color
                      } border-2 p-3 rounded ${
                        isSelected ? "selected-segment" : ""
                      }`}
                      onClick={() =>
                        setSelectedHeatMapItem(isSelected ? null : itemKey)
                      }
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="flex-grow-1">
                          <div className="comp_head_new">{item.name}</div>
                          <div className="comp_subhead_new">
                            {item.players} player{item.players > 1 ? "s" : ""} •{" "}
                            {item.players === 4
                              ? "Very crowded"
                              : item.players === 3
                              ? "Competitive"
                              : item.players === 2
                              ? "Moderate"
                              : "Unique"}
                          </div>
                          {item.marketSize && (
                            <div className="comp_head_number">
                              {item.marketSize}
                            </div>
                          )}
                        </div>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedDetailModal(itemKey);
                          }}
                          className="btn btn-sm btn-link p-0 ms-2"
                          title="Click for detailed analysis"
                        >
                          <Search size={18} className="text-primary" />
                        </button>
                      </div>
                    </div>

                    {isSelected && (
                      <div className="mt-2 ms-2 p-3 bg-white rounded border border-primary border-2 shadow-sm">
                        <div className="small fw-bold mb-2">
                          Companies serving this segment:
                        </div>
                        <div className="d-flex flex-wrap gap-1">
                          {item.companies.map((company, compIdx) => (
                            <span
                              key={compIdx}
                              className={`badge ${
                                company === "H.B. Fuller"
                                  ? "bg-primary"
                                  : company === "Henkel"
                                  ? "bg-danger"
                                  : company === "Bostik"
                                  ? "bg-info"
                                  : "bg-secondary"
                              }`}
                            >
                              {company}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          <div className="row g-2 p-3 bg-light rounded mt-3">
            <div className="col-3">
              <div className="d-flex align-items-center gap-2 small">
                <div
                  className="bg-custom-danger-only"
                  style={{ width: "1rem", height: "1rem", borderRadius: "2px" }}
                ></div>
                <div>
                  <div className="fw-bold">Very Crowded</div>
                  <div className="text-muted">4 players</div>
                </div>
              </div>
            </div>
            <div className="col-3">
              <div className="d-flex align-items-center gap-2 small">
                <div
                  className="bg-custom-info-only"
                  style={{ width: "1rem", height: "1rem", borderRadius: "2px" }}
                ></div>
                <div>
                  <div className="fw-bold">Competitive</div>
                  <div className="text-muted">3 players</div>
                </div>
              </div>
            </div>
            <div className="col-3">
              <div className="d-flex align-items-center gap-2 small">
                <div
                  className="bg-custom-warning-only"
                  style={{ width: "1rem", height: "1rem", borderRadius: "2px" }}
                ></div>
                <div>
                  <div className="fw-bold">Moderate</div>
                  <div className="text-muted">2 players</div>
                </div>
              </div>
            </div>
            <div className="col-3">
              <div className="d-flex align-items-center gap-2 small">
                <div
                  className="bg-custom-success-only"
                  style={{ width: "1rem", height: "1rem", borderRadius: "2px" }}
                ></div>
                <div>
                  <div className="fw-bold">Unique</div>
                  <div className="text-muted">1 player</div>
                </div>
              </div>
            </div>
          </div>

          <div className="score_inter mt-2 mb-2">
            <div className="d-flex gap-2">
              {/* <Users size={20} className="flex-shrink-0 mt-1" /> */}
              <img src="/img/bullseye.png" width="16" height="16"/>
              <div className="small">
                <strong>Customer Segment Battle Map:</strong> Construction
                Contractors ($12.5B) is largest segment but Bostik dominates
                (32% share). Packaging Converters ($10.8B) is H.B. Fuller's #1
                battlefield—leading at 32%. Automotive OEMs ($8.2B, 7.1% CAGR)
                is future growth engine.{" "}
                <strong>
                  H.B. Fuller CROWN JEWELS: Hygiene Manufacturers ($4.2B, 48%
                  share, 32% of revenue) is profit engine—DEFEND AT ALL COSTS.
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Customer Intelligence Grid */}
      <div className="row g-3">
        {companies.map((company) => (
          <div key={company.id} className="col-md-6">
            <div
              className={`intelligence-card bg-${company.bgColor} bg-opacity-10 border-${company.bgColor}`}
            >
              <h4 className="h6 fw-bold font14">{company.name}</h4>
              <div className="mb-2">
                <div className="small text-muted text-uppercase fw-semibold mb-1 font13">
                  Key Strength
                </div>
                <p className="small mb-0 font13">
                  {customerIntelligence[company.id].highlight}
                </p>
              </div>
              <div className="">
                <div className="small fst-italic text-muted font13">
                  "{customerIntelligence[company.id].quote}"
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerIntelligence;
